import PositionList from '@/controllers/position/position-list.js';
import CONFIG from "@/assets/js/config.custom.js";
import axios from 'axios';

export default {
  extends: PositionList,
  data() {
    return {
      CONFIG,
      type: '',
      searchData: {
        type: ''
      },
    };
  },
  methods: {
    search(page = 1) {
      this.isLoading = true;
      this.search_status = true;
      this.currentPage = page;
      axios.get('position/search?page=' + page, {
        params: {
          position_name: this.searchData.position_name,
          description: this.searchData.description,
          min_salary: this.searchData.min_salary,
          max_salary: this.searchData.max_salary,
          type: this.searchData.type,
        }
      })
        .then(res => {
          if (res.data) {
            this.positionLists = res.data;
          }
          this.isLoading = false;
        }).catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        })
    },

    reset() {
      this.positionName = '';
      this.description = '';
      this.minSalary = '';
      this.maxSalary = '';
      this.type = '';
      this.searchData = {
        position_name: '',
        description: '',
        min_salary: '',
        max_salary: '',
        type: ''
      }
      this.isLoading = true;
      this.getPositionLists();
    },

    filter() {
      this.search_status = false;
      this.searchData.position_name = this.positionName;
      this.searchData.description = this.description;
      this.searchData.min_salary = this.minSalary;
      this.searchData.max_salary = this.maxSalary;
      this.searchData.type = this.type;
      this.search();
    },
  },
}
